import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NotificationService } from '../../../../services/notification.service';
import { HttpClient } from '../../../../services/http.service';
import { ActivatedRoute } from '@angular/router';
import { PriceRankPipe } from '../../../../pipes/prices.pipe';
import { Subscription } from 'rxjs';
import { MaterialSelect2Service } from '../../../../modules/@material-input/component/material-select2.service';
import { DictionariesService } from '../../../../services/dictionaries.service';

@Component({
    selector: 'app-flat-common',
    templateUrl: './flat-common.component.html',
    styleUrls: ['./flat-common.component.scss'],
    standalone: false
})
export class FlatCommonComponent implements OnInit, OnDestroy {

  public data: any = null;
  public form: UntypedFormGroup;
  @Input() public flatId = null;
  public chain_list = [];
  public type_otd = [];
  public loading = true;
  private subscriptions: Array<Subscription> = [];

  constructor(public activeRoute: ActivatedRoute, public fb: UntypedFormBuilder, public http: HttpClient,
              public notify: NotificationService, public priceRank: PriceRankPipe,
              public select2Service: MaterialSelect2Service, private dict_helper: DictionariesService) {
  }

  public get rooms(): UntypedFormArray {
    return this.form.get('flat_rooms_description') as UntypedFormArray;
  }

  ngOnInit() {
    this.form = this.fb.group({
      'section_caption': [{'value': null, 'disabled': true}],
      'floor_caption': [{'value': null, 'disabled': true}],
      'housing_caption': [{'value': null, 'disabled': true}],
      'flat_category': [null],
      'flat_dog_bron': [null],
      'flat_etazh': [null],
      'flat_koef_balkonov': [null],
      'flat_koef_lodjiy': [null],
      'flat_kol_vo_balkonov': [null],
      'flat_kol_vo_lodjiy': [null],
      'flat_kol_vo_urovney': [null],
      'flat_num': [null],
      'flat_num_pp': [null],
      'flat_plochad_bez_neotaplivaemich': [null],
      'flat_plochad_obsh': [null],
      'flat_plosch_balkonov': [null],
      'flat_plosch_lodjiy': [null],
      'flat_ploshad_kuchni': [null],
      'flat_ploshad_shil': [null],
      'flat_pom_type': [null],
      'flat_price': [null],
      'flat_rooms': [null],
      'flat_section': [{value: '', disabled: true}],
      'flat_stoimost_kv_metra': [{value: null, disabled: true}],
      'flat_stoimost_kv_metra_ddu': [null],
      'flat_subagent_agd': [null],
      // 'realty_parent_chain_caption': [null],
      'flat_rooms_description': this.fb.array(this.getRooms([])),
    });

    if (this.flatId) {
      this.getData();
    }
  }

  getData() {
    this.http.resolvers({
      'data': this.http.post('Flat.get', {'realty_id': +this.flatId, 'tab': 'common'}),
      'dict_chainlist': this.dict_helper.get('Housing.get_chain'),
      'dict_type_otd': this.dict_helper.get('Dict.get_realty_type_otd'),
    }).then((resolvers) => {
      this.data = resolvers['data'];
      this.chain_list = resolvers['dict_chainlist'];
      this.type_otd = resolvers['dict_type_otd'];
      this.pathForm();
      this.loading = false;
    });
  }

  addRoom() {
    this.rooms.push(this.fb.group({
      'caption': '',
      'area': '',
    }));
  }

  dropRoom(index) {
    this.rooms.removeAt(index);
  }

  private getRooms(rooms: Array<{[p: string]: string}>) {
    return rooms.map(x => this.fb.group({
      'caption': x['caption'],
      'area': x['area'],
    }));
  }

  pathForm() {
    this.form.patchValue({
      'floor_caption': this.data['floor_caption'],
      'section_caption': this.data['section_caption'],
      'housing_caption': this.data['housing_caption'],
      'flat_category': this.data['flat_category'],
      'flat_dog_bron': this.data['flat_dog_bron'],
      'flat_etazh': this.data['flat_etazh'],
      'flat_koef_balkonov': this.data['flat_koef_balkonov'],
      'flat_koef_lodjiy': this.data['flat_koef_lodjiy'],
      'flat_kol_vo_balkonov': this.data['flat_kol_vo_balkonov'],
      'flat_kol_vo_lodjiy': this.data['flat_kol_vo_lodjiy'],
      'flat_kol_vo_urovney': this.data['flat_kol_vo_urovney'],
      'flat_num': this.data['flat_num'],
      'flat_num_pp': this.data['flat_num_pp'],
      'flat_plochad_bez_neotaplivaemich': this.data['flat_plochad_bez_neotaplivaemich'],
      'flat_plochad_obsh': this.data['flat_plochad_obsh'],
      'flat_plosch_balkonov': this.data['flat_plosch_balkonov'],
      'flat_plosch_lodjiy': this.data['flat_plosch_lodjiy'],
      'flat_ploshad_kuchni': this.data['flat_ploshad_kuchni'],
      'flat_ploshad_shil': this.data['flat_ploshad_shil'],
      'flat_pom_type': this.data['flat_pom_type'],
      'flat_price': this.data['flat_price'],
      'flat_rooms': this.data['flat_rooms'],
      'flat_section': this.data['flat_section'],
      'flat_stoimost_kv_metra': this.data['flat_stoimost_kv_metra'],
      'flat_stoimost_kv_metra_ddu': this.data['flat_stoimost_kv_metra_ddu'],
      'flat_subagent_agd': this.data['flat_subagent_agd'],
      // 'realty_parent_chain_caption': this.data['realty_parent_chain_caption'],
    });
    this.select2Service.reload();
    this.getRooms(this.data['flat_rooms_description'] || []).forEach(item => {
      this.rooms.push(item);
    });
    this.addSubscriptions();
  }

  saveForm() {
    if (!this.form.valid) {
      this.onError('Заполните обязательные поля');
      return false;
    }
    let data = this.form.value;
    this.http.post('Flat.update_flat',
      {'realty_id': +this.flatId, 'data': {'common': this.form.value}}
    ).subscribe(
      (response) => this.onSuccess(response),
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', error, 5000);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private changeSquareTotal() {
    setTimeout(_ => {
      if (this.form.value['flat_ploshad_shil'] && this.form.value['flat_ploshad_kuchni']) {
        let flat_ploshad_shil = this.form.value['flat_ploshad_shil'];
        let flat_ploshad_kuchni = this.form.value['flat_ploshad_kuchni'];

        flat_ploshad_shil = parseFloat(flat_ploshad_shil.toString().replace(',', '.'));
        flat_ploshad_kuchni = parseFloat(flat_ploshad_kuchni.toString().replace(',', '.'));

        if (flat_ploshad_shil && flat_ploshad_kuchni && !this.form.value['flat_plochad_obsh']) {
          this.form.patchValue({
            'flat_plochad_obsh': (flat_ploshad_shil + flat_ploshad_kuchni).toFixed(2),
          }, {onlySelf: true});
        }
      }
    }, 100);
  }

  private changeSquareNP() {
    setTimeout(_ => {
      let flat_plochad_obsh = this.form.value['flat_plochad_obsh'];
      let flat_plosch_balkonov = this.form.value['flat_plosch_balkonov'];
      let flat_plosch_lodjiy = this.form.value['flat_plosch_lodjiy'];

      let flat_koef_balkonov = this.form.value['flat_koef_balkonov'];
      let flat_koef_lodjiy = this.form.value['flat_koef_lodjiy'];

      flat_koef_balkonov = flat_koef_balkonov && parseFloat(flat_koef_balkonov.toString().replace(',', '.')) || 0;
      flat_koef_lodjiy = flat_koef_lodjiy && parseFloat(flat_koef_lodjiy.toString().replace(',', '.')) || 0;

      flat_plochad_obsh = flat_plochad_obsh && parseFloat(flat_plochad_obsh.toString().replace(',', '.')) || 0;
      flat_plosch_balkonov = flat_plosch_balkonov && parseFloat(flat_plosch_balkonov.toString().replace(',', '.')) || 0;
      flat_plosch_lodjiy = flat_plosch_lodjiy && parseFloat(flat_plosch_lodjiy.toString().replace(',', '.')) || 0;

      if (flat_plochad_obsh && (flat_plosch_balkonov || flat_plosch_lodjiy)) {
        this.form.patchValue({
          'flat_plochad_bez_neotaplivaemich': (flat_plochad_obsh - flat_plosch_balkonov * flat_koef_balkonov
            - flat_plosch_lodjiy * flat_koef_lodjiy).toFixed(2),
        }, {onlySelf: true});
      }

    }, 100);
  }

  private refreshPrices(type = 'total') {
    setTimeout(_ => {
      let flat_price = this.form.value['flat_price'];
      let flat_plochad_obsh = this.form.value['flat_plochad_obsh'];
      let flat_stoimost_kv_metra = this.form.value['flat_stoimost_kv_metra'];


      flat_price = flat_price && parseFloat(flat_price.toString().replace(',', '.')) || 0;
      flat_plochad_obsh = flat_plochad_obsh && parseFloat(flat_plochad_obsh.toString().replace(',', '.')) || 0;
      flat_stoimost_kv_metra = flat_stoimost_kv_metra && parseFloat(flat_stoimost_kv_metra.toString().replace(',', '.')) || 0;

      if (!flat_plochad_obsh) {
        return;
      }

      if (type === 'total') {
        this.form.get('flat_stoimost_kv_metra').setValue(
          (flat_price / flat_plochad_obsh).toFixed(2),
          {onlySelf: true}
        );
      }
    }, 100);
  }

  private addSubscriptions() {
    this.subscriptions.push(this.form.get('flat_ploshad_shil').valueChanges
      .subscribe(_ => this.changeSquareTotal()));

    this.subscriptions.push(this.form.get('flat_ploshad_kuchni').valueChanges
      .subscribe(_ => this.changeSquareTotal()));

    this.subscriptions.push(this.form.get('flat_plochad_obsh').valueChanges
      .subscribe(_ => this.changeSquareNP()));

    this.subscriptions.push(this.form.get('flat_plosch_balkonov').valueChanges
      .subscribe(_ => this.changeSquareNP()));

    this.subscriptions.push(this.form.get('flat_plosch_lodjiy').valueChanges
      .subscribe(_ => this.changeSquareNP()));

    this.subscriptions.push(this.form.get('flat_price').valueChanges
      .subscribe(_ => this.refreshPrices()));
  }
}
